import React from "react";
import CountrySelectionPage from "./pages/CountrySelectionPage/CountrySelectionPage";
import CountryPage from "./pages/CountryPage/CountryPage";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import {
  englishTranslatedAssets,
  englishTranslations,
} from "./pages/CountryPage/Props/english";
import {
  germanTranslatedAssets,
  germanTranslations,
} from "./pages/CountryPage/Props/german";
import { spanishTranslatedAssets,
  spanishTranslations,
} from "./pages/CountryPage/Props/spanish";
import { UsercentricsConsentManager } from "./Components/UserCentricsConsentManager/UserCentricsConsentManager";

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<CountrySelectionPage />} />

        <Route
          path="/germany"
          element={
            <CountryPage
              translations={germanTranslations}
              assets={germanTranslatedAssets}
            />
          }
        />
        <Route
          path="/germany/privacy-policy"
          element={<PrivacyPolicyPage countryCode="de" languageCode="de" />}
        />

        <Route
          path="/uk"
          element={
            <CountryPage
              translations={englishTranslations}
              showSponsor={true}
              assets={englishTranslatedAssets}
            />
          }
        />
        <Route
          path="/uk/privacy-policy"
          element={<PrivacyPolicyPage countryCode="gb" languageCode="en" />}
        />

        <Route
          path="/australia"
          element={
            <CountryPage
              translations={englishTranslations}
              assets={englishTranslatedAssets}
            />
          }
        />
        <Route
          path="/australia/privacy-policy"
          element={<PrivacyPolicyPage countryCode="au" languageCode="en" />}
        />

        <Route
          path="/canada"
          element={
            <CountryPage
              translations={englishTranslations}
              assets={englishTranslatedAssets}
            />
          }
        />
        <Route
          path="/canada/privacy-policy"
          element={<PrivacyPolicyPage countryCode="ca" languageCode="en" />}
        />
        <Route
          path="/spain"
          element={
            <CountryPage
              translations={spanishTranslations}
              assets={spanishTranslatedAssets}
            />
          }
        />
        <Route
          path="/spain/privacy-policy"
          element={<PrivacyPolicyPage countryCode="es" languageCode="es" />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <UsercentricsConsentManager />
    </>
  );
};

export default App;
